import React, { useMemo } from "react";
import BadgeMultiSelect from "../../common/BadgeMultiSelect/BadgeMultiSelect";
import { buildStudyGateOptions } from "./isfStudyGateService";

export default function IsfPhaseFilter({
  gates = [],
  value = [],
  onChange,
  disabled = false,
}) {
  const options = useMemo(
    () =>
      buildStudyGateOptions(gates).map((gate) => ({
        value: gate.code,
        label: gate.name,
      })),
    [gates],
  );

  return (
    <BadgeMultiSelect
      options={options}
      value={value}
      onChange={onChange}
      emptyLabel="All phases"
      addLabel="+"
      popoverTitle="Filter by phase"
      popoverSubtitle="Select one or more study phases"
      compactSummary
      disabled={disabled}
    />
  );
}
